// Cómo se pagó la compra de un activo fijo (H20). Antes el diálogo no lo preguntaba:
// la compra nacía PAGADA en efectivo sin mover ninguna caja y el mayor la dejaba en
// Cuentas por pagar. Al contado sale de una cuenta; a crédito queda en Por Pagar.
export const PAYMENT_TERMS = [
    { label: 'Contado', value: 'contado' },
    { label: 'Crédito', value: 'credito' },
];

// Campos de pago del payload, o `error` si falta algo. Un activo que ya se tenía antes del
// corte no lleva compra y no pide nada.
export function assetPaymentFields(form) {
    if (form.isOpening) return { fields: {} };
    if (form.paymentTerm === 'credito') {
        const days = Number(form.creditDays);
        if (!Number.isInteger(days) || days <= 0) return { error: 'Indica el plazo en días.' };
        return { fields: { creditDays: days } };
    }
    if (form.paymentTerm === 'contado') {
        if (form.accountId === null || form.accountId === undefined || form.accountId === '') {
            return { error: 'Elige la cuenta de la que salió el dinero.' };
        }
        return { fields: { creditDays: 0, accountId: form.accountId } };
    }
    return { error: 'Elige cómo pagaste el activo.' };
}

// Cliente de la venta de una baja (H21): salía a CONSUMIDOR FINAL y quedaba en Por Cobrar sin
// nombre. Devuelve el id a mandar, o `error` si se vende sin elegirlo.
export function disposalCustomer(disposal) {
    if (!disposal.isSale) return { customerId: null };
    const customer = disposal.customer;
    if (!customer || typeof customer !== 'object' || customer.id === undefined || customer.id === null) {
        return { error: 'Elige a quién se lo vendes.' };
    }
    return { customerId: customer.id };
}
